class TabbedProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.tabbed-carousel__tab');
    this.panels = this.querySelectorAll('.tabbed-carousel__panel');
    this.init();
  }

  init() {
    if (this.tabs.length === 0 || this.panels.length === 0) return;

    // Add click event listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
    });

    // Initialize slider components when panels become active
    this.observePanels();
  }

  switchTab(index) {
    // Update tab states
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('tabbed-carousel__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    // Update panel visibility
    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      if (isActive) {
        panel.classList.add('tabbed-carousel__panel--active');
        panel.removeAttribute('hidden');
      } else {
        panel.classList.remove('tabbed-carousel__panel--active');
        panel.setAttribute('hidden', '');
      }
    });

    // Reinitialize slider components in the active panel after it's visible (so dimensions are correct)
    const activePanel = this.panels[index];
    if (activePanel) {
      this.initSliders(activePanel);
      document.dispatchEvent(new CustomEvent('tabbed-carousel-tab-changed', { detail: { panel: activePanel } }));
    }
  }

  observePanels() {
    // Use MutationObserver to detect when panels become visible
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
          const panel = mutation.target;
          if (!panel.hasAttribute('hidden')) {
            this.initSliders(panel);
          }
        }
      });
    });

    this.panels.forEach((panel) => {
      observer.observe(panel, {
        attributes: true,
        attributeFilter: ['hidden']
      });
    });
  }

  initSliders(panel) {
    // Sliders in hidden panels have zero dimensions at page load, so they never init properly.
    // When this panel becomes visible, force each slider to recalculate after layout.
    const sliderComponents = panel.querySelectorAll('slider-component');
    const runAfterLayout = () => {
      sliderComponents.forEach((slider) => {
        if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
      });
      // Re-run carousel progress bar logic for this section (section-carousel-slider.js)
      window.dispatchEvent(new Event('resize'));
    };
    // Wait for browser to lay out the newly visible panel
    requestAnimationFrame(() => {
      requestAnimationFrame(runAfterLayout);
    });
    setTimeout(runAfterLayout, 150);
  }
}

customElements.define('tabbed-product-carousel', TabbedProductCarousel);
